import React from 'react';
import PropTypes from 'prop-types';
import VideoPlayer, { VideoPlayerT } from 'components/VideoPlayer';
import ArrowButton from 'components/ArrowButton';
import classNames from 'classnames';
import Slider from 'react-slick';
import classes from './VideoPlayerListA.module.scss';

const VideoPlayerListA = (props) => {
  let cssClass = '';
  const { items = [], cssClass: originalCssClass = '' } = props;
  cssClass = originalCssClass || 'bg-blue-green';
  const onCarousel = items.length > 1;
  const arrowProps = {
    iconClassName: classNames('fa-4x', classes.arrow),
    type: 'ArrowButtonA',
  };

  if (onCarousel) {
    return (
      <div className={classNames(classes.container, cssClass)}>
        <div className={classes.wrapper}>
          <hr className={classes.hr} />
          <div className={classes.slidesContainer}>
            <Slider
              dots
              infinite
              speed={500}
              autoplay
              autoplaySpeed={7500}
              prevArrow={<ArrowButton {...arrowProps} />}
              nextArrow={<ArrowButton {...arrowProps} isNext />}
              pauseOnHover
              slidesToShow={1}
              slidesToScroll={1}
            >
              {items.map((slide, index) => (
                <div key={index} className={classes.slide}>
                  <VideoPlayer item={slide} cssClass={cssClass} onCarousel />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  }

  return items[0] && <VideoPlayer item={items[0]} />;
};

VideoPlayerListA.propTypes = {
  /**
   * A list of Video Player Item Objects
  */
  items: PropTypes.arrayOf(VideoPlayerT),
  /**
   * Custom css class applied
  */
  cssClass: PropTypes.string,
};

export default VideoPlayerListA;
